import { render, staticRenderFns } from "./AddDepartmentDialog.vue?vue&type=template&id=88ff5066&"
import script from "./AddDepartmentDialog.vue?vue&type=script&lang=js&"
export * from "./AddDepartmentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports